<template>
    <v-container fluid>
      <v-slide-y-transition mode="out-in">
        <v-layout align-center justify-center my-5 column>
          <v-flex>
            <!-- <img src="@/assets/logo.png" alt="Vuetify.js"> -->
            Health Ok!
          </v-flex>
        </v-layout>
      </v-slide-y-transition>
    </v-container>
  </template>

<script>
export default {
  name: 'healthCheck',
  props: {
    msg: String
  }
}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  
  img {
      top: 50%;
      height: 200px;
      width: auto;
      margin-top: 200px;
  }
  </style>
  